export default __webpack_public_path__ + "static/media/optin.e8ce3fce.svg";